module.exports = __webpack_public_path__ + "static/img/img_mall_3d.83d7028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_mall_3d.png
// module id = 4Yw9
// module chunks = 1